import { render, staticRenderFns } from "./SnippetEditor.vue?vue&type=template&id=3cf1263b&"
import script from "./SnippetEditor.vue?vue&type=script&lang=js&"
export * from "./SnippetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports